import { Controller } from 'stimulus';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  static values = { boardsPaneOpenClass: String };

  show() {
    this.element.classList.remove('hidden');
    this.#outlineSidepanelThumb();
  }

  // Shift the popover up (out of the way) while the boards pane is open, matching
  // how the canvas moves. Driven by moodboard--board-list:toggled@document.
  adjustForBoardsPane({ detail: { open } }) {
    this.element.classList.toggle(this.boardsPaneOpenClassValue, open);
  }

  close() {
    document.querySelector('.demo-thumb')?.classList.remove('demo-thumb');
    this.element.remove();
    this.#markWalkthroughShown();
  }

  #markWalkthroughShown() {
    const body = { kind: 'moodboard_walkthrough_shown' };
    const request = new FetchRequest('POST', '/user_actions', { body });
    request.perform().catch(console.error);
  }

  #outlineSidepanelThumb() {
    document.dispatchEvent(
      new CustomEvent('switch-sidepanel', {
        detail: { sidepanelId: 'products', active: true },
      })
    );

    const thumb = document.querySelector(
      '.moodboard--drawer--sidepanel.is-active [data-controller*="thumb"]'
    );
    if (thumb) {
      thumb.classList.add('demo-thumb');
    }
  }
}
